import { linkEditing } from '@yola/ws-sdk';
import fieldNames, { BOOLEAN_FIELD_NAME_SUFFIX } from '../constants/field-names';
import downloadOptions from '../constants/download-options';
import extractFieldsValuesFromLinkConfig from './extract-fields-values-from-link-config';

const { BLANK } = linkEditing.constants.common;

const getRequiredFieldsValues = (linkConfig) => {
  const values = {};
  const isTargetBlank = linkConfig?.target === BLANK;

  values[fieldNames.DOWNLOAD_OPTION] = isTargetBlank
    ? downloadOptions.OPEN_IN_NEW_TAB
    : downloadOptions.DOWNLOAD_ON_COMPUTER;
  values[fieldNames.DOWNLOAD_CUSTOM_PATH] = '/';

  return values;
};

const getEmptyFieldsValues = () =>
  Object.values(fieldNames).reduce((acc, fieldName) => {
    const isBooleanField = fieldName.endsWith(BOOLEAN_FIELD_NAME_SUFFIX);

    return {
      ...acc,
      [fieldName]: isBooleanField ? false : '',
    };
  }, {});

const getDefaultFieldsValues = (linkConfig) => {
  const extractedValues = extractFieldsValuesFromLinkConfig(linkConfig);
  const defaultValues = getEmptyFieldsValues();
  const requiredValues = getRequiredFieldsValues(linkConfig);

  // Initialize all fields with empty strings to avoid constant resetting and setting values
  // for fields that are only supported by certain link types.
  return {
    ...defaultValues,
    ...requiredValues,
    ...extractedValues,
  };
};

export default getDefaultFieldsValues;
